import React from 'react'
import { CFView } from 'components'
import { COLOR } from 'styles'

export default ({ label, disabled, onClick, ...props }) => {
  return (
    <CFView
      h="45px"
      bg={disabled ? COLOR.disabled : COLOR.brand}
      br="25px"
      ph="30px"
      boxShadow="1px 1px 3px rgba(0,0,0,.8)"
      center
      hover
      onClick={!disabled ? onClick : undefined}
      {...props}
    >
      <CFView white bold>
        {label}
      </CFView>
    </CFView>
  )
}
